import ImgPerkenalanKeluarga from '@assets/images/perkenalan-keluarga.jpg';
import cartachicoestasconociendo from '@assets/images/cartachicoestasconociendo.jpg';
import Comienzo from '@assets/images/comienzo.jpg';
import PrimeraFecha from '@assets/images/primerafecha.jpg';
import SegundaFecha from '@assets/images/segundafecha.jpg';
import TerceraFecha from '@assets/images/tercerafecha.jpg';
import CuartaFecha from '@assets/images/cuartafecha.jpg';
import QuintaFecha from '@assets/images/quitafecha.jpg';


export const stories = [
  {
    title: 'Comienzo',
    date: '',
    description:
      'Tan cerca y tan lejos, aún no era el momento… Quién lo diría, que nueve años después si lo sería, el inicio de algo especial. Desde esa primera sonrisa y el brillo en los ojos, todo indicaba que había magia en el aire. True Love, ambos lo sabíamos.',
    image: Comienzo,
  },
  {
    title: 'Primera Fecha',
    date: 'Julio 2019',
    description:
      'Nuestro primer viaje juntos. Kilómetros recorridos, historias compartidas y sueños para el futuro. Un deseo en común ¡vivir!, sumar nuevas experiencias, conectar y amar... ¿y por qué no? nuevos platillos y postres jaja.',
    image: PrimeraFecha,
  },
  {
    title: 'Ganando Confianza',
    date: 'Diciembre 2019',
    description:
      'Todo fue más natural y las palabras fluyeron con más confianza. Mientras compartíamos una tarde en el parque, nos dimos cuenta de que nos unían los sueños, recuerdos, amigos y el deseo de un buen café.',
    image: SegundaFecha,
  },
  {
    title: 'Vínculos Más Profundos',
    date: 'Enero 2021',
    description:
    'Después de varios años juntos, nuestras conversaciones habían adquirido una profundidad única. Sabíamos que podíamos hablar de todo, desde nuestras dudas hasta nuestros sueños más grandes. En esta etapa, la relación estaba marcada por la confianza y un entendimiento mutuo que solo el tiempo puede construir.',    image: TerceraFecha,
  },
  {
    title: 'Compartiendo Más',
    date: 'Diciembre 2023',
    description:
    'Con los años, reflexionamos sobre todo lo que habíamos vivido juntos. Las experiencias compartidas y los años de amistad y amor nos habían unido profundamente. Sabíamos que habíamos construido algo fuerte y genuino, y estábamos listos para dar el siguiente paso.',    image: CuartaFecha,
  },
  {
    title: 'El Gran Compromiso',
    date: '24 Agosto 2024',
    description:
      'El día más especial de todos, nos comprometimos a pasar la vida juntos. Fue un momento lleno de emoción y promesas, un cierre perfecto para todos los hermosos recuerdos compartidos, y el inicio de un nuevo capítulo en nuestra historia.',
    image: QuintaFecha,
  },
];
